<template>
  <div class="wxpay-container">
    <!-- 支付信息展示 -->
    <div class="payment-info">
      <div class="amount"><span class="label">商品名：</span><span class="value">申诉费用</span></div>
      <div class="amount">
        <span class="label">支付金额：</span>
        <span class="value">¥{{ amount }}</span>
      </div>
      <div class="order-number">
        <span class="label">订单号：</span>
        <span class="value">{{ orderNo }}</span>
      </div>
      <p style="color: red;text-align: center;margin-bottom: 20px;">请长按扫码支付!</p>
      <div id="qrCodeUrl" ref="qrCodeUrl" class="qrcode-container" />
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      amount: "0.00", // 支付金额
      orderNo: "", // 订单号
      paymentStatus: "", // 支付状态
      qrcode: null,
      paymentLink: "", // 微信支付链接
    };
  },
  created() {
    this.initPayment();
  },
  mounted() {
    this.getPayQRCode();
  },
  methods: {
    // 初始化支付
    initPayment() {
      // 从路由参数中获取支付链接
      this.paymentLink = decodeURIComponent(this.$route.query.link);
      this.orderNo = this.$route.query.orderNo;
      this.amount = (this.$route.query.totalAmount * 1) / 100;
      if (!this.paymentLink) {
        console.error("支付链接不存在");
        return;
      }
    },

    // 处理支付
    handlePayment() {
      if (this.paymentLink) {
        const decodedPaymentLink = decodeURIComponent(this.paymentLink);
        // 微信小程序环境
        // if (typeof wx !== "undefined" && wx.miniProgram) {
        //
        // } else {
        //   // H5 环境
        // }
        window.location.href = decodedPaymentLink;

        wx.miniProgram.navigateTo({
          url: `${decodedPaymentLink}`,
        });
      } else {
        console.error("支付链接不存在");
      }
    },
    getCoed(url) {
      this.$nextTick(() => {
        this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
          width: 400, // 宽
          height: 400, // 高
          text: url, // 二维码内容,也可以直接放接口获取的数据
        });
      });
    },
    async getPayQRCode() {
      this.getCoed(this.paymentLink);
    },
  },
};
</script>

<style scoped>
.wxpay-container {
  padding: 20px;
  max-width: 500px;
  margin: 0 auto;
}

.payment-info {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.amount,
.order-number {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.label {
  color: #666;
}

.value {
  color: #333;
  font-weight: bold;
}

.pay-button {
  width: 100%;
  padding: 15px;
  background-color: #07c160;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
}

.pay-button:active {
  background-color: #06ad56;
}

.payment-status {
  margin-top: 20px;
  text-align: center;
  font-size: 18px;
  color: #07c160;
}

.payment-status p {
  margin: 0;
}
.qrcode-container {
  display: flex;
  justify-content: center;
}
</style>
